import React from 'react';

import { BooleanCellContent } from '@sharedCR/coreDesignSystem/Table/TableCDS/cellContent';
import dayjs from 'dayjs';
import _ from 'lodash';

import { COMMON_DATETIME_FORMAT } from 'constants/date';
import { HORIZONTAL_ALIGNMENT } from 'constants/ui';
import { alwaysTrue } from 'utils/data';

import { qualifiedIncomesColumns } from './Incomes.constants';
import UnderwritingAlertsCell from './UnderwritingAlertsCell';

export const validationRulesTableConfig = {
  ruleName: {
    label: 'Report Name',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    sort: true,
  },
  isValid: {
    label: 'Valid',
    align: HORIZONTAL_ALIGNMENT.CENTER,
    sort: true,
    content: ({ isValid }) => <BooleanCellContent isChecked={isValid} />,
  },
  date: {
    label: 'Date',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    sort: true,
    renderContentAsText: alwaysTrue,
    content: ({ date }) => dayjs(date).format(COMMON_DATETIME_FORMAT),
  },
  underwritingAlerts: {
    label: 'Underwriting Alerts',
    align: HORIZONTAL_ALIGNMENT.LEFT,
    sort: true,
    tooltip: 'Text Color: white - Informational, yellow - Warning, red - Severe',
    content: ({ underwritingAlerts }) => (
      <UnderwritingAlertsCell underwritingAlerts={underwritingAlerts} />
    ),
  },
};

export const qualifiedIncomesTableConfig = qualifiedIncomesColumns.reduce((config, column) => {
  config[column.id] = {
    label: column.label,
    align: column.align,
    sort: column.sort,
    renderContentAsText: alwaysTrue,
    content: income => (_.isNil(income[column.id]) ? '-' : income[column.id]),
  };

  return config;
}, {});
